<template>
  <div class="content">
    <v-header></v-header>
    <h3>{{ typeCached === 1 ? $parseLabel("公告通知") : $parseLabel("帮助中心") }}</h3>
    <ul>
      <li
        v-for="(item, index) in items"
        :key="index"
        :style="
          index % 2 == 0
            ? 'background-color: #f6faff'
            : 'background-color: #fff'
        "
      >
        <div class="cons">
          <p>{{ typeCached === 1 ? item.title : item.name }}</p>
          <span>发布时间：{{ item.createdTime }}</span>
        </div>
        <div class="status">
          <el-button v-if="typeCached === 1" @click="open(item)" type="primary" size="medium">{{ $parseLabel('查看') }}</el-button>
          <el-button v-else @click="openDoc(item)" type="primary" size="medium">{{ $parseLabel('查看信息') }}</el-button>
        </div>
      </li>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="pageChange"
          :page-sizes="[10, 50, 100, 150, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
        ></el-pagination>
      </div>
    </ul>

    <div ref="file"></div>

    <el-dialog :title="$parseLabel('提示')" :visible.sync="dataDialogVisible" width="30%">
      <span>{{ content }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dataDialogVisible = false"
          >{{ $parseLabel('我已知晓') }}</el-button
        >
      </span>
    </el-dialog>
    <v-footer></v-footer>
  </div>
</template>
      
<script>
import { getNotificationList, getFileList } from "@/api/list";
import { getDocumentByPath } from "@/api/kpi"
import header from "@/components/header.vue";
import footer from "@/components/footer.vue";
import moment from "moment";
import axios from "axios";
export default {
  data() {
    return {
      typeCached: undefined,
      items: [],
      pageNum: 1,
      pageSize: 10,
      total: undefined,
      title: "",
      content: "",
      dataDialogVisible: false,
    };
  },
  components: {
    "v-header": header,
    "v-footer": footer,
    moment
  },
  watch: {
    "$route.query.type": {
      handler() {
        this.reloadList();
      },
    },
  },
  created() {
    this.reloadList();
  },
  methods: {
    reloadList() {
      this.items = [];
      this.total = undefined;
      this.typeCached = parseInt(this.$route.query.type);
      if(this.typeCached === 1) {
        this.getTodoList();
      } else {
        this.getFileList();
      }
    },
    open(item) {
      this.content = item.content;
      this.dataDialogVisible = true;
    },
    openDoc(item) {
      let _this = this;
      if (_this.isURL(item.path) == true) {
        _this.handleFileDownload(item.name, item.path);
      } else {
        if (_this.isNumber(item.path) == true) {
          getDocumentByPath(parseInt(item.path)).then(res => {
            if (res.success) {
              _this.handleFileDownload(item.name, res.data.path);
            }
          }).catch(err=>{
            _this.msgError(err);
          });
        }
      }
    },
    handleSizeChange(e) {
      this.pageSize = e;
      this.reloadList();
    },
    pageChange(e) {
      this.pageNum = e;
      this.reloadList();
    },
    handleFileDownload(fileName, fileUrl) {
      let realFileName = fileName + moment().format('YYYYMMDDHHmmSS');
      let fileSuffix = fileUrl.substring(fileUrl.lastIndexOf("."));
      const downloadFileName = realFileName + fileSuffix;

      this.ccxGetBlob(fileUrl).then(blob => {
        this.ccxSaveAs(blob, downloadFileName)
      })
    },
    getTodoList() {
      getNotificationList(this.pageNum, this.pageSize).then((res) => {
        if (res.success) {
          res.data.list.forEach((list) => {
            list.createdTime = moment(list.createTime).format("YYYY-MM-DD");
          });
          this.items = res.data.list;
          this.total = res.data.total;
        }
      });
    },
    getFileList() {
      getFileList(this.pageNum, this.pageSize).then((res) => {
        if (res.success) {
          res.data.list.forEach((list) => {
            list.createdTime = moment(list.createTime).format("YYYY-MM-DD");
          });
          this.items = res.data.list;
          this.total = res.data.total;
        }
      });
    },
  },
};
</script>
      
<style lang="less" scoped>
h3 {
  width: 85%;
  height: 130px;
  line-height: 130px;
  color: #192c7d;
  text-align: center;
  font-weight: 800;
  font-size: 30px;
  position: relative;
  // &::after {
  //     position: absolute;
  //     content: "";
  //     width: 100px;
  //     height: 2px;
  //     background: #192c7d;
  //     display: block;
  //     right: 0;
  // }
}
ul {
  width: 85%;
  margin: 20px auto;
  li {
    width: 100%;
    height: auto;
    list-style: none;
    display: flex;
    justify-content: space-between;
    padding: 10px;
    .cons {
      display: flex;
      flex-direction: column;
      text-indent: 15px;
      padding-top: 6px;
      padding-bottom: 6px;
      p {
        color: #192c7d;
        font-weight: 800;
        font-size: 16px;
      }
      span {
        color: #666666;
        font-size: 13px;
        padding-top: 3px;
      }
    }
    .status {
      display: flex;
      align-items: center;
      position: relative;
      right: 15px;
      font-size: 14px;
    }
  }
}
</style>